import { request } from './request';
import { getAdminEndpoint } from './getEndpoint';

export function validateMailingList(
	file: File | Blob | undefined,
	url: string,
	fieldName = 'file',
	clientId?: string,
) {
	if (!file) return Promise.reject();
	const data = new FormData();
	data.append(fieldName, file);

	return request({
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		method: 'POST',
		url: getAdminEndpoint(url),
		params: { clientId },
		file: data,
	});
}

export function uploadFileToDB(
	file: File | Blob | undefined,
	url: string,
	fieldName = 'file',
) {
	const data = new FormData();
	if (file) {
		data.append(fieldName, file);
	}
	return request({
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		method: 'POST',
		url: getAdminEndpoint(url),
		file: data,
	});
}

export function getFileFromDB(url: string, data: Record<string, any>) {
	return request({
		method: 'GET',
		url: getAdminEndpoint(url),
		data,
	});
}

export function deleteFileFromDB(url: string, data: any) {
	return request({
		method: 'DELETE',
		url: getAdminEndpoint(url),
		data,
	}).catch((e) => e);
}
